import React from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress } from "@mui/material";

import "./button.scss";

function CustomButton({
  label,
  onClick,
  variant = "contained",
  color = "primary",
  size = "medium",
  startIcon = null,
  endIcon = null,
  isDisabled = false,
  isLoading = false,
  isFullWidth = false,
  className = "",
  disableHoverEffect = false,
  ...other
}) {
  function getColorClass() {
    if (isLoading) {
      return `button-${variant}-loading`;
    }
    return isDisabled ? `button-${variant}-disabled` : `button-${variant}-${color}`;
  }

  function getSizeClass() {
    let name = `button-${size}`;

    if (variant === "text") {
      name += ` button-text-${size}-padding`;
    } else {
      name += ` button-${size}-padding`;
    }

    return name;
  }

  return (
    <Button
      className={`${getColorClass()} ${getSizeClass()} ${className} button min-w-max-content ${
        disableHoverEffect ? "no-hover" : ""
      }`}
      size={size}
      variant={variant}
      disabled={isDisabled}
      onClick={!isLoading ? onClick : null}
      startIcon={startIcon}
      endIcon={endIcon}
      fullWidth={isFullWidth}
      {...other}
    >
      {isLoading ? <CircularProgress size={25} color="inherit" /> : label}
    </Button>
  );
}

CustomButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["contained", "outlined", "text"]),
  color: PropTypes.oneOf([
    "inherit-white",
    "inherit-text",
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
  ]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  disableHoverEffect: PropTypes.bool,
};

CustomButton.defaultProps = {
  variant: "contained",
  color: "primary",
  size: "medium",
  startIcon: null,
  endIcon: null,
  isDisabled: false,
  isLoading: false,
  isFullWidth: false,
  disableHoverEffect: false,
};

export default CustomButton;
